import React from 'react';

import PropTypes from 'prop-types';

import styled from 'styled-components';

const IllustrationComponent = styled.figure`
    margin: 0;
    padding: 0;

    img {
        border: none;
        height: auto;
        max-width: 100%;
        vertical-align: top;
    }
`;

const PromoIllustration = (props) => {
    const [imgA, imgA2x, imgB, imgB2x, imgC, imgC2x] = props.img;

    const getDecoding = () => {
        if (props.loadingLazy) {
            return 'async';
        }
        if (props.fetchPriorityHigh) {
            return 'sync';
        }
        return null;
    };
    return (
        <IllustrationComponent>
            {props.img && imgA && imgA2x && imgB && imgB2x && imgC && imgC2x && (
                <picture>
                    {imgC2x && <source srcSet={`${imgC?.url} 1x, ${imgC2x?.url} 2x`} height={imgC?.height} width={imgC?.width} media="(min-width: 1440px)" />}
                    <source srcSet={`${imgB?.url} 1x, ${imgB2x?.url} 2x`} height={imgB?.height} width={imgB?.width} media="(min-width: 744px)" />
                    <source srcSet={`${imgA?.url} 1x, ${imgA2x?.url} 2x`} height={imgA?.height} width={imgA?.width} />
                    <img
                        src={imgC?.url}
                        alt={imgC?.alternativeText}
                        width={imgC?.width}
                        height={imgC?.height}
                        loading={props.loadingLazy ? 'lazy' : null}
                        decoding={getDecoding()}
                        fetchpriority={props.fetchPriorityHigh ? 'high' : null}
                    />
                </picture>
            )}
            {props.img && !props.width && imgA && imgA2x && !imgB && !imgB2x && !imgC && (
                <picture>
                    <source srcSet={`${imgA?.url} 1x, ${imgA2x?.url} 2x`} height={imgA?.height} width={imgA?.width} />
                    <img
                        src={imgA?.url}
                        alt={imgA?.alternativeText}
                        width={imgA?.width}
                        height={imgA?.height}
                        loading={props.loadingLazy ? 'lazy' : null}
                        decoding={getDecoding()}
                        fetchpriority={props.fetchPriorityHigh ? 'high' : null}
                    />
                </picture>
            )}
            {props.img && props.width && imgA && imgA2x && !imgB && !imgB2x && !imgC && (
                <picture>
                    <source srcSet={`${imgA?.url} 1x, ${imgA2x?.url} 2x`} height={imgA?.height} width={imgA?.width} />
                    <img
                        src={imgA?.url}
                        alt={imgA?.alternativeText}
                        width={imgA2x?.width}
                        height={imgA2x?.height}
                        loading={props.loadingLazy ? 'lazy' : null}
                        decoding={getDecoding()}
                        fetchpriority={props.fetchPriorityHigh ? 'high' : null}
                    />
                </picture>
            )}
            {props.img && imgA && !imgA2x && !imgB && !imgB2x && !imgC && (
                <picture>
                    <img
                        src={imgA?.url}
                        alt={imgA?.alternativeText}
                        width={imgA?.width}
                        height={imgA?.height}
                        loading={props.loadingLazy ? 'lazy' : null}
                        decoding={getDecoding()}
                        fetchpriority={props.fetchPriorityHigh ? 'high' : null}
                    />
                </picture>
            )}
        </IllustrationComponent>
    );
};
PromoIllustration.propTypes = {
    img: PropTypes.array,
    loadingLazy: PropTypes.bool,
    fetchPriorityHigh: PropTypes.bool,
};
export default PromoIllustration;
